export const getElevationFromNumber = (elevationNumber) => {
    switch (elevationNumber) {
        case 1:
            return elevation.primary1;
        case 2:
            return elevation.primary2;
        case 3:
            return elevation.primary3;
        case 4:
            return elevation.primary4;
        case 5:
            return elevation.primary5;
        default:
            return undefined;
    }
};
export const elevation = {
    primary1: `
    0px 2px 8px -2px rgba(0, 0, 0, 0.25)
    `,
    primary2: `
    0px 4px 16px -4px rgba(0, 0, 0, 0.25)
    `,
    primary3: `
    0px 8px 32px -8px rgba(0, 0, 0, 0.25)
    `,
    primary4: `
    0px 16px 48px -12px rgba(0, 0, 0, 0.25)
    `,
    primary5: `
    0px 32px 64px -16px rgba(0, 0, 0, 0.25)
    `,
    cardBackground: `
    0px 16px 48px -12px rgba(0, 0, 0, 0.4)
    `,
    cardInset: `
    0px -1px 0.5px 0px rgba(0, 0, 0, 0.20) inset,
    0px 1px 0.5px 0px rgba(255, 255, 255, 0.20) inset
    `,
};
//# sourceMappingURL=elevation.js.map